import { DollarSign, Clock, MailSearch } from "lucide-react";

const problems = [
  {
    icon: DollarSign,
    text: "CRMs are expensive and complex",
    description: "Salesforce, HubSpot, and Pipedrive cost hundreds per month and require extensive training.",
  },
  {
    icon: Clock,
    text: "Manual contact work steals your time",
    description: "Copy-pasting names, companies, and phone numbers from emails takes hours every week.",
  },
  {
    icon: MailSearch,
    text: "Your contacts live in email threads",
    description: "Important people get buried in your inbox with no structure, no tags, no context.",
  },
];

export const Problem = () => {
  return (
    <section className="py-24 bg-muted/30">
      <div className="container px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Not everyone needs a full CRM.
            </h2>
            <p className="text-xl text-muted-foreground leading-relaxed max-w-3xl mx-auto">
              Heavy CRM platforms are overkill for most professionals. You don't need pipelines, sales stages, or 50-page manuals. You just need smart contact management in Outlook — the tool you already use every day.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6">
            {problems.map((problem, index) => (
              <div 
                key={index}
                className="bg-card rounded-xl p-8 shadow-card border border-border"
              >
                <div className="mb-4 inline-flex p-3 rounded-lg bg-destructive/10">
                  <problem.icon className="w-6 h-6 text-destructive" />
                </div>
                <h3 className="text-xl font-bold mb-3 text-foreground">
                  {problem.text}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {problem.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
